import React from "react";
import "./PortfolioGrid.scss"; // Import your stylesheet
import SeeProjectButton from "../SeeProjectButton/SeeProjectButton";
import project1Image from "../../assets/images/logo-design-beech-nurseries-l-a-media.jpg";
import project2Image from "../../assets/images/logo-design-real-estate-logo.jpg";
import project3Image from "../../assets/images/logo-design-lake-erie-studios-l-a-media.jpg";
import project4Image from "../../assets/images/beech-nursery-price-list-printed-catalogue-front.webp";
import project5Image from "../../assets/images/print-design-vinyl-banner-job-fair-garden-nursery.webp";
import project6Image from "../../assets/images/hall-tree-spading-billboard-la-design.jpg";
import project7Image from "../../assets/images/hall-tree-spading-brochure-print-graphic-design.webp";
import project8Image from "../../assets/images/billboard-garden-nursery-toronto-ontario.jpg";
import project9Image from "../../assets/images/puma-retouched-photoshop-post-production.gif";
import project10Image from "../../assets/images/infographic-tech-cloud-design.jpg";

const PortfolioGrid = () => {
  const projects = [
    {
      id: 1,
      image: project1Image,
      description: 'Logo rebrand',
      href: "/case-study/beech-nurseries",
    },
    {
      id: 2,
      image: project2Image,
      description: 'Real estate logo',
    },
    {
      id: 3,
      image: project3Image,
      description: 'Logo design for a recording studio',
    },
    {
      id: 4,
      image: project4Image,
      description: 'Catalogue design, page layout and production',
      href: "/case-study/beech-nurseries",
    },
    {
      id: 5,
      image: project5Image,
      description: 'Vinyl banner - print design',
    },
    {
      id: 6,
      image: project6Image,
      description: 'Billboard - print design',
    },
    {
      id: 7,
      image: project7Image,
      description: 'Brochure - design and production',
    },
    {
      id: 8,
      image: project8Image,
      description: 'Wayfinding Billboard',
    },
    {
      id: 9,
      image: project9Image,
      description: 'High-end retouching services',
    },
    {
      id: 10,
      image: project10Image,
      description: 'Infographic',
    },
    // Add more projects as needed
  ];

  return (
    <div className="portfolio-grid-container">
      {projects.map(project => (
        <div className="portfolio-grid__item" key={project.id}>
          <div className="portfolio-grid__item__image-container">
            <img 
              src={project.image} 
              alt={`${project.title} - ${project.description}`} 
            />
             <SeeProjectButton 
    label="See Project"
    href={project.href}
    variant="primary"
  />
          </div>
        
        </div>
      ))}
    </div>
  );
};

export default PortfolioGrid;
